/**
 * Порядок реквизитов способа выплат.
 *
 * С бэкенда поля приходят массивами `partner_fields_keys` / `manager_fields_keys`,
 * и их порядок не совпадает с макетом. Поэтому порядок задаётся здесь и
 * применяется на всех экранах: форма создания, деталка заявки, карточка способа
 * в администрировании.
 *
 * Способа нет в карте - поля показываются в том порядке, в котором пришли.
 * Это осознанно: переставлять поля там, где макета нет, не нужно.
 */
export const PAYOUT_METHOD_FIELDS_ORDER: Record<string, readonly string[]> = {
    bank_card_ru_v1: ['card_number', 'cardholder_name', 'phone', 'bank_name'],
};

/**
 * Возвращает новый массив ключей реквизитов в порядке макета.
 * Ключи, которых нет в карте порядка, уходят в конец, сохраняя исходный
 * порядок между собой (`Array.prototype.sort` стабилен).
 */
export function sortPayoutMethodFields<T extends string>(fields: readonly T[], methodId?: string): T[] {
    const order = methodId ? PAYOUT_METHOD_FIELDS_ORDER[methodId] : undefined;

    if (!order) {
        return [...fields];
    }

    const rank = (field: string): number => {
        const index = order.indexOf(field);
        return index === -1 ? order.length : index;
    };

    return [...fields].sort((a, b) => rank(a) - rank(b));
}
